import { Box, Modal } from "@mui/material";
import styles from "./IFrameModal.module.css";

interface IFrameModalProps {
  isModalOpen: boolean;
  handleCloseModal: any;
  modalContent: string;
}

export default function IFrameModal(props: IFrameModalProps) {
  const { isModalOpen, handleCloseModal, modalContent } = props;
  return (
    <Modal open={isModalOpen} onClose={handleCloseModal}>
      <Box className={styles.modelContainer}>
        <iframe
          src={modalContent}
          title="Content Preview"
          className={styles.iframe}
        ></iframe>
      </Box>
    </Modal>
  );
}
